module.exports = __webpack_public_path__ + "img/wallet.959db0a2.svg";